// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Tag = function Tag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.16 1.445c.664 0 1.3.262 1.77.73l6.875 6.876a2.5 2.5 0 0 1 0 3.535L12.59 17.8a2.5 2.5 0 0 1-3.535 0L2.18 10.926a2.48 2.48 0 0 1-.735-1.766V3.32c0-1.035.84-1.875 1.875-1.875zM3.32 9.16c0 .164.067.324.184.442l6.875 6.875c.242.242.64.242.883 0l5.215-5.215a.627.627 0 0 0 0-.883L9.602 3.504a.63.63 0 0 0-.442-.184H3.32zm2.5-4.59a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
  }));
};
